<script setup lang="ts">
import { LazyExtraDiscountModal } from '#components'

const props = defineProps<{
  item: Record<string, any>
}>()

const overlay = useOverlayWithAd()

// defineEmits(['openDiscountModal'])
async function openDiscountModal(discount) {
  const modal = overlay.create(LazyExtraDiscountModal, {
    props: { discount },
  })
  modal.open()
}
</script>

<template>
  <div class="flex-1 flex flex-col p-4 relative overflow-hidden bg-white text-center rounded-md">
    <!-- EXTRA or GRATUIT badge -->
    <div
      v-if="item.type === 'EXTRA'"
      class="py-2 leading-3 origin-top float-right mb-5 mr-3 w-30 mt-3 text-center absolute top-0 right-0 text-poivre-600"
      style="transform:translateX(50%) rotate(45deg); background: linear-gradient(135deg, #e5d9a2 0%, #f0e8be 40%, #f7f2df 50%, #f0e8be 60%, #e5d9a2 100%);"
    >
      <div class="text-xs uppercase font-semibold">
        EXTRA
      </div>
    </div>
    <div
      v-else
      class="py-2 leading-3 origin-top float-right mb-5 mr-3 w-30 mt-3 text-center absolute top-0 right-0 text-poivre-600"
      style="transform:translateX(50%) rotate(45deg); background-color: #ebeced;"
    >
      <div class="text-xs uppercase font-semibold">
        GRATUIT
      </div>
    </div>

    <!-- Content -->
    <dl class="mt-1 flex-grow flex flex-col">
      <dd class="text-poivre-500 text-sm mt-2 border-0 block mx-auto h-20 flex justify-center items-center">
        <img
          :src="`${$config.public.backendCdnUrl}/u/discounts/${item.logo_path}`"
          class="max-h-full object-contain border-0"
        >
      </dd>
      <dd class="mt-2">
        <p class="px-2 py-1 font-medium">
          {{ item.title }}
        </p>
        <p class="px-2 py-1 text-sm" v-html="item.description" />
      </dd>
      <dd class="text-sm text-poivre-500 my-2 flex flex-wrap justify-center gap-1">
        <div class="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-bleuet rounded-full">
          <UIcon name="i-mdi-store" class="mr-1" />
          <span>{{ item.availability }}</span>
        </div>
        <div class="inline-flex items-center px-2 py-1 ml-1 text-white text-xs font-medium bg-sauge rounded-full">
          <UIcon name="i-mdi-map-marker" class="mr-1" />
          <span>{{ item.location }}</span>
        </div>
      </dd>
    </dl>

    <!-- Action -->
    <dl class="mt-2">
      <UButton class="" label="Réclamer le rabais" @click="openDiscountModal(item)" />
    </dl>
  </div>
</template>
